/**
 * @description - Convert date to MM/DD/YYYY (12/30/1997) formate
 * @param {string} date
 * @returns {string} string
 */
export const convertDate = (date = new Date()) => {
  const nDate = new Date(date);
  return (
    (nDate.getMonth() > 8
      ? nDate.getMonth() + 1
      : "0" + (nDate.getMonth() + 1)) +
    "/" +
    (nDate.getDate() > 9 ? nDate.getDate() : "0" + nDate.getDate()) +
    "/" +
    nDate.getFullYear()
  );
};
export const weekArr = [
  { 1: "WEEK ONE" },
  { 2: "WEEK TWO" },
  { 3: "WEEK THREE" },
  { 4: "WEEK FOUR" },
  { 5: "WEEK FIVE" },
  { 6: "WEEK SIX" },
  { 7: "WEEK SEVEN" },
  { 8: "WEEK EIGHT" },
];
export const convertWeekStrtoNum = (data) => {
  let final;
  weekArr.filter((d) => {
    if (Object.keys(d) === data) {
      final = d[data];
    }
  });
  return final;
};

export const delay = (cb, time = 1000) => {
  let timer = setTimeout(() => {
    cb();
    clearTimeout(timer);
  }, time)

  return timer;
};

export const generateRandomNumber = (max) => {
  return Math.floor(Math.random() * max);
}

export const removeDuplicates = (array, key = null) => {
  if (!key) {
    // Handle arrays of primitive values
    return [...new Set(array.filter(item => item != null && item !== ''))];
  }

  // Handle arrays of objects with a specified key
  const map = new Map();
  array.forEach(item => map.set(item[key], item));
  return [...map.values()];
};

export const removeValueInArray = (array, valueToRemove) => {
  return array.filter(item => item !== valueToRemove);
};

export const allFieldsHaveValue = (obj, exemptions = []) => {
  if (!obj || typeof obj !== 'object') return false;

  return Object.entries(obj).every(([key, value]) => {
    if (exemptions.includes(key)) return true; // Skip validation for exempted keys

    if (Array.isArray(value)) {
      return value.length > 0;
    }

    return value != null && value !== ''; // Checks for both undefined and null
  });
};

export function sanitizeAndParseJSON(jsonString) {
  try {
    // Remove leading and trailing whitespace
    let cleanedString = jsonString.trim();

    // Handle cases where JSON might have trailing commas
    cleanedString = cleanedString.replace(/,\s*}$/, '}').replace(/,\s*]$/, ']');

    // Handle cases where JSON might have extra characters or incorrect quotes
    cleanedString = cleanedString.replace(/'/g, '"'); // Convert single quotes to double quotes

    // Parse JSON
    const parsedObject = JSON.parse(cleanedString);

    return parsedObject;
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return null;
  }
}